import {
  defineComponent,
  reactive,
  watch,
  ref,
  getCurrentInstance,
  onMounted
} from '@vue/composition-api'
import './index.scss'
import _ from 'lodash'
import { Message, MessageBox } from '@gcommon/gcommon-ui'
// import i18n from '@/locales'
import VueI18n from 'vue-i18n'

const UploadTopic = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    type: {
      //1:单选题  2:多选题
      type: Number,
      default: 1
    },
    i18n: {
      type: VueI18n
    }
  },
  emits: ['completeEdit'],
  setup(props, context) {
    const { emit } = context
    //i18n 国际化
    const instance = getCurrentInstance()
    const tran = function (initParam) {
      return instance?.proxy.$t(initParam) as string
    }
    const state = reactive({
      editItem: _.cloneDeep(props.item), //编辑数据源
      errorText: ''
    })
    const fileList = ref(props.item?.value ? JSON.parse(props.item?.value) : [])
    watch(
      () => props.item,
      (val) => {
        state.editItem = _.cloneDeep(val)
      },
      {
        deep: true
      }
    )
    const openSurveyId = ref(window.sessionStorage.getItem('openSurveyId'))
    const handlePreview = (file) => {
      const { file: fileDetail, type } = file
      // console.log(fileDetail)
      // /.*(\.jpg|\.gif|\.bmp|\.jpeg|\.webp|\.png|\.JPG|\.GIF|\.BMP|\.JPEG|\.WEBP|\.PNG|)$/
      if (!fileDetail.raw?.type.includes('image')) {
        Message.warning(
          (props.i18n?.t('survy.notAllowOreview') as string) ||
            tran('survy.notAllowOreview')
        )
        return
      }
      let divPack = document.createElement('div')
      let ImgPack = document.createElement('img')
      divPack.appendChild(ImgPack)
      divPack.setAttribute('class', 'previewImgPack')
      divPack.onclick = (e) => {
        document.body.removeChild(divPack)
      }
      // divPack.addEventListener('click',)
      ImgPack.src = fileDetail?.response?.data
      ImgPack.setAttribute('class', 'imgPack')
      document.body.appendChild(divPack)
      // console.log(fileDetail)
    }

    const handleDownload = (file) => {
      const { file: fileDetail, type } = file
      let a: HTMLAnchorElement | null = document.createElement('a')
      a.href = fileDetail?.response?.data
      a.download = fileDetail.name
      a.click()
      a = null
    }

    const handleRemove = (file, fileListAfter) => {
      fileList.value = fileListAfter
    }

    const handleFileSizeCheck = (file) => {
      if (file.size >= 10485760) {
        setTimeout(() => {
          Message.warning(
            `${
              props.i18n?.t('survy.uploadWarining1') ||
              tran('survy.uploadWarining1')
            } ${file?.name} ${
              props.i18n?.t('survy.uploadWarining2') ||
              tran('survy.uploadWarining2')
            }`
          )
        }, 10)
        return false
      } else {
        return true
      }
    }

    const gcommonAnnexUploadAcitve = (file, fileList) => {
      let _type = file.type
      const buttonFuncMap = {
        preview: handlePreview,
        download: handleDownload
      }
      buttonFuncMap?.[_type]?.(file)
    }

    const handleExceed = (files, fileList) => {
      Message.warning(
        `${props.i18n?.t('survy.uploadMaxNum') || tran('survy.uploadMaxNum')} ${
          state?.editItem?.topicSetting?.maxAppendixNum ?? 9
        } ${
          props.i18n?.t('survy.uploadMaxNum1') || tran('survy.uploadMaxNum1')
        }`
      )
    }
    const beforeRemove = (file) => {
      if (file.status === 'success') {
        return MessageBox.confirm(
          `${
            props.i18n?.t('survy.confirmDelete') || tran('survy.confirmDelete')
          } ${file.name}？`,
          '',
          {
            customClass: 'deleteConfirm',
            confirmButtonText: `${
              props.i18n?.t('common.sure') || tran('common.sure')
            } `,
            cancelButtonText: `${
              props.i18n?.t('common.cancel') || tran('common.cancel')
            } `
          }
        )
      }
    }
    const uploadError = (err, file, fileList) => {
      Message.error(
        `${file.name} ${
          props.i18n?.t('survy.uoloadfail') || tran('survy.uoloadfail')
        }`
      )
    }
    const uploadChange = (files, fileListAfter) => {
      if (files.status === 'success') {
        if (files.response.code === 5018) {
          const afterDelete = fileListAfter.filter(
            (item) => item.raw.uid !== files.raw.uid
          )
          handleRemove(files, afterDelete)
          setTimeout(() => {
            Message.warning(
              `${
                props.i18n?.t('survy.uploadWarining1') ||
                tran('survy.uploadWarining1')
              } ${files?.name} ${
                props.i18n?.t('survy.uploadWarining5') ||
                tran('survy.uploadWarining5')
              }`
            )
          }, 10)
          return
        }
        fileList.value = fileListAfter
      }
    }

    watch(
      () => fileList.value,
      (val: any[]) => {
        const res = val.map((item) => {
          return {
            name: item?.name ?? '',
            type: item?.raw?.type ?? '',
            url: item?.response?.data ?? ''
          }
        })
        state.editItem.value = JSON.stringify(res)
        state.editItem.values = fileList.value
        if (res.length) {
          state.editItem.isShowTitleError = false
        }
        emit('answer', state.editItem)
      },
      { deep: true }
    )

    onMounted(() => {
      setTimeout(() => {
        openSurveyId.value = window.sessionStorage.getItem('openSurveyId')
      }, 1200)
    })
    return () => {
      const uploadList =
        (state.editItem.value && JSON.parse(state.editItem.value)) || []
      return (
        <div class="fill-topic-content">
          {[
            '/v2/front/dataAnalysis/surveyData',
            '/v2/front/dataAnalysis/userData/detail',
            '/v2/front/survey/answerInfo'
          ].includes(window.location.pathname) ? (
            //为了答案统计展示做耦合
            <div class="data_analysis_upload">
              {uploadList.map((item) => {
                if (item.type.includes('image')) {
                  return <img src={item.url} alt={item.name} />
                } else {
                  return <div>{item.name}</div>
                }
              })}
            </div>
          ) : (
            //正常的答题主体部分
            <flycode-upload
              // action={`/v2/feedback/answer/upload?isPublic=true&openSurveyId=${window.sessionStorage.getItem('openSurveyId')}`}
              // action={`/v2/feedback/answer/upload?isPublic=true`}
              action={`/v2/survey/public/answer/upload?isPublic=true`}
              multiple={true}
              show-file-list={true}
              file-list={fileList.value}
              list-type="text"
              ref="gcommonAnnexUpload"
              readonly={false}
              data={{
                openSurveyId: openSurveyId.value
              }}
              activeList={['delete', 'preview']} //'edit','download'
              props={{
                'file-list': fileList.value,
                'on-activefile': gcommonAnnexUploadAcitve,
                'on-exceed': handleExceed,
                'before-remove': beforeRemove,
                'on-error': uploadError,
                'on-change': uploadChange,
                'on-remove': handleRemove,
                'before-upload': handleFileSizeCheck
                // 'on-success'
              }}
              limit={state?.editItem?.topicSetting?.maxAppendixNum ?? 9} //取动态的topicSetting
              class="survey_upload_topic">
              <div class="upload_button">
                <i
                  class="el-icon-upload"
                  style={{ color: 'var(--primary)', fontSize: '40px' }}></i>
                {/* <el-button type="text">+ {tran('survy.clickUpload')}</el-button> */}
              </div>
              <div slot="tip" class="upload_tips">
                {props.i18n?.t('survy.uploadMaxSize') ||
                  tran('survy.uploadMaxSize')}
              </div>
            </flycode-upload>
          )}
        </div>
      )
    }
  }
})

export default UploadTopic
